import { getRecurrenceDefinitions } from '../endpoints/getRecurrenceDefinitions';

// A recurrence definition narrowed to the identifiers an LOV row renders. Server
// pagination defaults are small — pass a generous limit so the client-side
// Typeahead filter has every option to match against.
export interface RecurrenceDefinitionSummary {
  readonly recurrence_definition_id: number;
  readonly name: string;
  readonly zone_name: string;
}

const LOV_LIMIT = 1000;

export const loadRecurrenceDefinitionsLOV = async (): Promise<readonly RecurrenceDefinitionSummary[]> => {
  const { nodes } = await getRecurrenceDefinitions({ limit: LOV_LIMIT });
  // Map, not just narrow: the list row's `zone_name` is nullable, but an LOV
  // option needs a string — a definition with no zone renders as ''.
  return nodes.map((node) => ({
    recurrence_definition_id: node.recurrence_definition_id,
    name: node.name,
    zone_name: node.zone_name ?? '',
  }));
};
